import Vue from 'vue';
import Router from 'vue-router';
import {
  ifAuthenticated,
  hasRights,
  allowModuleAccess,
  pageNotFound,
} from '@/helpers/routeHelpers';

// Layouts

// Modules
import Dashboard from '@/modules/dashboard/Dashboard.vue';
import UsergroupsOverview from '@/modules/usergroups/overview/UsergroupsOverview.vue';
import UsergroupsDetail from '@/modules/usergroups/detail/UsergroupsDetail.vue';
import UsergroupsAdd from '@/modules/usergroups/add/UsergroupsAdd.vue';
import UsersOverview from '@/modules/users/overview/UsersOverview.vue';
import UsersDetail from '@/modules/users/detail/UsersDetail.vue';
import UsersInvite from '@/modules/users/invite/UsersInvite.vue';
import LogOverview from '@/modules/log/overview/LogOverview.vue';
import LogDetail from '@/modules/log/detail/LogDetail.vue';
import Help from '@/modules/help/Help.vue';
import HelpDetail from '@/modules/help/HelpDetail.vue';
import AuthWrapper from '@/modules/auth/AuthWrapper.vue';
import MeProfile from '@/modules/me/profile/MeProfile.vue';
import LibraryOverview from '@/modules/library/overview/LibraryOverview.vue';
import ImageEditor from '@/modules/library/editor/ImageEditor.vue';
import LibraryDetail from '@/modules/library/detail/LibraryDetail.vue';
import BlogPostOverview from '@/modules/blog/overview/BlogPostOverview.vue';
import EditBlogPost from '@/modules/blog/detail/BlogPost.vue';
import TagsOverview from '@/modules/tags/overview/TagsOverview.vue';
import TagDetail from '@/modules/tags/detail/TagDetail.vue';
import NewsPostOverview from '@/modules/news/post/overview/NewsPostOverview.vue';
import NewsPost from '@/modules/news/post/detail/NewsPost.vue';
import PressOverview from '@/modules/press/post/overview/PressPostOverview.vue';
import PressPost from '@/modules/press/post/detail/PressPost.vue';
import CategoryDetail from '@/modules/categories/detail/CategoryDetail.vue';
import CategoryOverview from '@/modules/categories/overview/CategoryOverview.vue';

import PageDetail from '@/modules/page/detail/PageDetail.vue';
import PageOverview from '@/modules/page/overview/PageOverview.vue';

import PopupOverview from '@/modules/popups/overview/PopupOverview.vue';
import PopupDetail from '@/modules/popups/detail/PopupDetail.vue';

import FaqCategoryDetail from '@/modules/faq/categories/detail/FaqCategoryDetail.vue';
import FaqOverview from '@/modules/faq/overview/FaqOverview.vue';
import FaqQuestionDetail from '@/modules/faq/questions/detail/FaqQuestionDetail.vue';

import RedirectDetail from '@/modules/redirect/detail/RedirectDetail.vue';
import RedirectOverview from '@/modules/redirect/overview/RedirectOverview.vue';

import WhitelistDetail from '@/modules/whitelist/detail/WhitelistDetail.vue';
import WhitelistOverview from '@/modules/whitelist/overview/WhitelistOverview.vue';

import MenuItemDetail from '@/modules/menu/item/MenuItemDetail.vue';
import MenuOverview from '@/modules/menu/overview/MenuOverview.vue';
import MenuDetail from '@/modules/menu/detail/MenuDetail.vue';

import PromotionDetail from '@/modules/sites/lemniscaat/promotion/PromotionDetail.vue';
import PromotionOverview from '@/modules/sites/lemniscaat/promotion/PromotionOverview.vue';

import EducationDetail from '@/modules/sites/lemniscaat/education/EducationDetail.vue';
import EducationOverview from '@/modules/sites/lemniscaat/education/EducationOverview.vue';

import ReactionDetail from '@/modules/sites/lemniscaat/reaction/ReactionDetail.vue';
import ReactionOverview from '@/modules/sites/lemniscaat/reaction/ReactionOverview.vue';

import MagazineDetail from '@/modules/sites/lemniscaat/magazine/MagazineDetail.vue';
import MagazineOverview from '@/modules/sites/lemniscaat/magazine/MagazineOverview.vue';
import EditionDetail from '@/modules/sites/lemniscaat/magazine/edition/EditionDetail.vue';

import EmailsOverview from '@/modules/sites/lemniscaat/emails/overview/EmailsOverview.vue';
import EmailDetail from '@/modules/sites/lemniscaat/emails/detail/EmailDetail.vue';

import BookStoreDetail from '@/modules/sites/lemniscaat/bookstore/BookStoreDetail.vue';
import BookStoreOverview from '@/modules/sites/lemniscaat/bookstore/BookStoreOverview.vue';

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import OutsideLayout from '@/layouts/OutsideLayout.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    //  '/'
    {
      path: '/',
      component: DefaultLayout,
      beforeEnter: ifAuthenticated,
      children: [
        //  ''
        {
          path: '',
          redirect: {
            name: 'Dashboard',
          },
        },
        //  '/dashboard'
        {
          path: '/dashboard',
          name: 'Dashboard',
          meta: {
            title: 'dashboard',
            help: 'module.name.dashboard',
          },
          component: Dashboard,
        },
        //  'faq'
        {
          path: 'faq',
          name: 'FaqOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'faq',
            help: 'module.name.faq',
            permission: 'faq',
          },
          component: FaqOverview,
        },
        //  'faq/category/add'
        {
          path: 'faq/category/add',
          name: 'FaqCategoryAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'add',
            help: 'module.name.faq',
            permission: 'faq.category.add',
          },
          component: FaqCategoryDetail,
        },
        //  'faq/category/:id'
        {
          path: 'faq/category/:id',
          name: 'FaqCategoryDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'edit',
            help: 'module.name.faq',
            permission: 'faq.category.edit',
          },
          component: FaqCategoryDetail,
        },
        //  'faq/question/add'
        {
          path: 'faq/question/add',
          name: 'FaqQuestionAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'add',
            help: 'module.name.faq',
            permission: 'faq.question.add',
          },
          component: FaqQuestionDetail,
        },
        //  'faq/category/:category/question/:id'
        {
          path: 'faq/category/:category/question/:id',
          name: 'FaqQuestionDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'faq',
            action: 'edit',
            help: 'module.name.faq',
            permission: 'faq.question.edit',
          },
          component: FaqQuestionDetail,
        },
        //  '/news'
        {
          path: '/news',
          name: 'NewsPostOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'news',
            help: 'module.name.news',
            permission: 'news',
          },
          component: NewsPostOverview,
        },
        //  '/news/add'
        {
          path: '/news/add',
          name: 'AddNewsPost',
          beforeEnter: hasRights,
          meta: {
            action: 'add',
            title: 'news',
            help: 'module.name.news',
            permission: 'news.add',
          },
          component: NewsPost,
        },
        //  '/news/:id'
        {
          path: '/news/:id',
          name: 'EditNews',
          beforeEnter: hasRights,
          meta: {
            action: 'edit',
            title: 'news',
            help: 'module.name.news',
            permission: 'news.edit',
          },
          component: NewsPost,
        },
        //  '/blog'
        {
          path: '/blog',
          name: 'BlogPostOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'blog',
            help: 'module.name.blog:',
            permission: 'blog',
          },
          component: BlogPostOverview,
        },
        //  '/blog/add'
        {
          path: '/blog/add',
          name: 'AddBlogPost',
          beforeEnter: hasRights,
          meta: {
            title: 'blog',
            help: 'module.name.blog',
            action: 'add',
            permission: 'blog.add',
          },
          component: EditBlogPost,
        },
        //  '/blog/:id'
        {
          path: '/blog/:id',
          name: 'EditBlog',
          beforeEnter: hasRights,
          meta: {
            title: 'blog',
            help: 'module.name.blog',
            action: 'edit',
            permission: 'blog.edit',
          },
          component: EditBlogPost,
        },
        //  '/page'
        {
          path: '/page',
          name: 'PageOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'page',
            help: 'module.name.page',
            permission: 'page',
          },
          component: PageOverview,
        },
        //  '/page/add'
        {
          path: '/page/add',
          name: 'AddPage',
          beforeEnter: hasRights,
          meta: {
            title: 'page',
            help: 'module.name.page',
            action: 'add',
            permission: 'page.add',
          },
          component: PageDetail,
        },
        //  '/page/:id'
        {
          path: '/page/:id',
          name: 'EditPage',
          beforeEnter: hasRights,
          meta: {
            title: 'page',
            help: 'module.name.page',
            action: 'edit',
            permission: 'page.edit',
          },
          component: PageDetail,
        },
        //  '/tag'
        {
          path: '/tag',
          name: 'TagsOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'tags',
            help: 'module.name.tags',
            permission: 'tag',
          },
          component: TagsOverview,
        },
        //  '/tag/add'
        {
          path: '/tag/add',
          name: 'TagAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'tags',
            help: 'module.name.tags',
            action: 'add',
            permission: 'tag.add',
          },
          component: TagDetail,
        },
        //  '/tag/:id'
        {
          path: '/tag/:id',
          name: 'TagDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'tags',
            help: 'module.name.tags',
            action: 'edit',
            permission: 'tag.edit',
          },
          component: TagDetail,
        },
        //  '/category'
        {
          path: '/category',
          name: 'CategoryOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'categories',
            help: 'module.name.categories',
            permission: 'category',
          },
          component: CategoryOverview,
        },
        //  '/category/add'
        {
          path: '/category/add',
          name: 'CategoryAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'category',
            help: 'module.name.category',
            action: 'add',
            permission: 'category.add',
          },
          component: CategoryDetail,
        },
        //  '/category/:id'
        {
          path: '/category/:id',
          name: 'CategoryDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'categories',
            help: 'module.name.categories',
            action: 'edit',
            permission: 'category.edit',
          },
          component: CategoryDetail,
        },
        //  '/press'
        {
          path: '/press',
          name: 'PressOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'press',
            help: 'module.name.press',
            permission: 'press',
          },
          component: PressOverview,
        },
        //  '/press/add'
        {
          path: '/press/add',
          name: 'AddPressPost',
          beforeEnter: hasRights,
          meta: {
            action: 'add',
            title: 'press',
            help: 'module.name.press',
            permission: 'press.add',
          },
          component: PressPost,
        },
        //  '/press/:id'
        {
          path: '/press/:id',
          name: 'EditPress',
          beforeEnter: hasRights,
          meta: {
            action: 'edit',
            title: 'press',
            help: 'module.name.press',
            permission: 'press.edit',
          },
          component: PressPost,
        },
        //  '/help'
        {
          path: '/help',
          name: 'Help',
          meta: {
            title: 'help',
          },
          component: Help,
        },
        //  '/help/:type'
        {
          path: '/help/:type',
          name: 'HelpDetailGeneral',
          meta: {
            title: 'help',
          },
          component: HelpDetail,
        },
        //  '/help/:type/:module'
        {
          path: '/help/:type/:module',
          name: 'HelpDetailModule',
          meta: {
            title: 'help',
          },
          component: HelpDetail,
        },
        //  '/usergroups'
        {
          path: '/usergroups',
          name: 'UsergroupsOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'usergroups',
            permission: 'usergroups',
            help: 'module.name.usergroups',
          },
          component: UsergroupsOverview,
        },
        //  '/usergroups/add'
        {
          path: '/usergroups/add',
          name: 'UsergroupsAdd',
          beforeEnter: hasRights,
          meta: {
            title: 'usergroups',
            action: 'add',
            permission: 'usergroups.add',
            help: 'module.name.usergroups',
          },
          component: UsergroupsAdd,
        },
        //  '/usergroups/:id'
        {
          path: '/usergroups/:id',
          name: 'UsergroupsDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'usergroups',
            action: 'edit',
            permission: 'usergroups.edit',
            help: 'module.name.usergroups',
          },
          component: UsergroupsDetail,
        },
        //  '/users'
        {
          path: '/users',
          name: 'UsersOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'users',
            permission: 'users',
            help: 'module.name.users',
          },
          component: UsersOverview,
        },
        //  '/users/invite'
        {
          path: '/users/invite',
          name: 'UsersInvite',
          beforeEnter: hasRights,
          meta: {
            title: 'users',
            action: 'invite',
            permission: 'users.add',
            help: 'module.name.users',
          },
          component: UsersInvite,
        },
        //  '/users/:id'
        {
          path: '/users/:id',
          name: 'UsersDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'users',
            permission: 'users.edit',
            action: 'edit',
            help: 'module.name.users',
          },
          component: UsersDetail,
        },
        //  '/logs'
        {
          path: '/logs',
          name: 'LogOverview',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'logs',
          },
          component: LogOverview,
        },
        //  '/logs/:id'
        {
          path: '/logs/:id',
          name: 'LogDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'logs',
            action: 'details',
            help: 'module.name.logs',
          },
          component: LogDetail,
        },
        //  '/profile'
        {
          path: '/profile',
          name: 'MeProfile',
          meta: {
            title: 'profile',
            help: 'module.name.profile',
          },
          component: MeProfile,
        },
        //  '/library'
        {
          path: '/library',
          name: 'Library',
          beforeEnter: allowModuleAccess,
          meta: {
            title: 'library',
            permission: 'library',
            help: 'module.name.library',
          },
          component: LibraryOverview,
        },
        //  '/library/:filename'
        {
          path: '/library/:filename',
          name: 'LibraryDetail',
          beforeEnter: hasRights,
          meta: {
            title: 'library',
            action: 'details',
            permission: 'library.edit',
            help: 'module.name.library',
          },
          component: LibraryDetail,
        },
        //  '/library/:filename/edit'
        {
          path: '/library/:filename/edit',
          name: 'LibraryEdit',
          meta: {
            title: 'library',
            action: 'edit',
            permission: 'library.edit',
            help: 'module.name.library',
          },
          component: ImageEditor,
        },
        //  '/navigation'
        {
          path: '/navigation',
          name: 'MenuOverview',
          meta: {
            title: 'navigation',
            help: 'module.name.menu',
          },
          component: MenuOverview,
        },
        //  '/navigation/add'
        {
          path: '/navigation/add',
          name: 'MenuAdd',
          meta: {
            title: 'navigation',
            permission: 'navigation.menu.add',
            action: 'add',
            help: 'module.name.menu',
          },
          component: MenuDetail,
        },
        //  '/navigation/:id/menu'
        // {
        //   path: '/navigation/:id/menu',
        //   name: 'MenuDetail',
        //   meta: {
        //     title: 'navigation',
        //     permission: 'navigation.menu',
        //     action: 'edit',
        //     help: 'module.name.menu',
        //   },
        //   component: MenuDetail,
        // },
        //  '/navigation/:id'
        {
          path: '/navigation/:id',
          name: 'MenuItemDetail',
          meta: {
            title: 'navigation',
            permission: 'navigation.menu.edit',
            action: 'edit',
            help: 'module.name.menu',
          },
          component: MenuItemDetail,
        },
        //  '/popup'
        {
          path: '/popup',
          name: 'PopupOverview',
          meta: {
            title: 'popup',
            help: 'module.name.popup',
          },
          component: PopupOverview,
        },
        //  '/popup/add'
        {
          path: '/popup/add',
          name: 'PopupAdd',
          meta: {
            title: 'popup',
            help: 'module.name.popup',
            action: 'add',
          },
          component: PopupDetail,
        },
        //  '/popup/:id'
        {
          path: '/popup/:id',
          name: 'PopupDetail',
          meta: {
            title: 'popup',
            help: 'module.name.popup',
            action: 'edit',
          },
          component: PopupDetail,
        },
        {
          path: '/redirect',
          name: 'RedirectOverview',
          meta: {
            title: 'redirect',
            help: 'module.name.redirect',
          },
          component: RedirectOverview,
        },
        {
          path: '/redirect/add',
          name: 'RedirectAdd',
          meta: {
            title: 'redirect',
            help: 'module.name.redirect',
            action: 'add',
          },
          component: RedirectDetail,
        },
        {
          path: '/redirect/:id',
          name: 'RedirectDetail',
          meta: {
            title: 'redirect',
            help: 'module.name.redirect',
            action: 'edit',
          },
          component: RedirectDetail,
        },
        {
          path: '/whitelist',
          name: 'WhitelistOverview',
          meta: {
            title: 'whitelist',
            help: 'module.name.whitelist',
          },
          component: WhitelistOverview,
        },
        {
          path: '/whitelist/add',
          name: 'WhitelistAdd',
          meta: {
            title: 'whitelist',
            help: 'module.name.whitelist',
            action: 'add',
          },
          component: WhitelistDetail,
        },
        {
          path: '/whitelist/:id',
          name: 'WhitelistDetail',
          meta: {
            title: 'whitelist',
            help: 'module.name.whitelist',
            action: 'edit',
          },
          component: WhitelistDetail,
        },
        {
          path: '/promotion',
          name: 'PromotionOverview',
          meta: {
            title: 'promotion',
            help: 'module.name.promotion',
          },
          component: PromotionOverview,
        },
        {
          path: '/promotion/add',
          name: 'PromotionAdd',
          meta: {
            title: 'promotion',
            help: 'module.name.promotion',
            action: 'add',
          },
          component: PromotionDetail,
        },
        {
          path: '/promotion/:id',
          name: 'PromotionDetail',
          meta: {
            title: 'promotion',
            help: 'module.name.promotion',
            action: 'edit',
          },
          component: PromotionDetail,
        },
        {
          path: '/education',
          name: 'EducationOverview',
          meta: {
            title: 'education',
            help: 'module.name.education',
          },
          component: EducationOverview,
        },
        {
          path: '/education/add',
          name: 'EducationDetail',
          meta: {
            title: 'education',
            help: 'module.name.education',
            action: 'add',
          },
          component: EducationDetail,
        },
        {
          path: '/education/:id',
          name: 'EducationAdd',
          meta: {
            title: 'education',
            help: 'module.name.education',
            action: 'edit',
          },
          component: EducationDetail,
        },
        {
          path: '/reaction',
          name: 'ReactionOverview',
          meta: {
            title: 'reaction',
            help: 'module.name.reaction',
          },
          component: ReactionOverview,
        },
        {
          path: '/reaction/add',
          name: 'ReactionAdd',
          meta: {
            title: 'reaction',
            help: 'module.name.reaction',
            action: 'add',
          },
          component: ReactionDetail,
        },
        {
          path: '/reaction/:id',
          name: 'ReactionDetail',
          meta: {
            title: 'reaction',
            help: 'module.name.reaction',
            action: 'edit',
          },
          component: ReactionDetail,
        },
        {
          path: '/magazine/:magazine/edition/add',
          name: 'EditionAdd',
          meta: {
            title: 'edition',
            help: 'module.name.magazine',
            action: 'add',
          },
          component: EditionDetail,
        },
        {
          path: '/magazine/:magazine/edition/:id',
          name: 'EditionDetail',
          meta: {
            title: 'edition',
            help: 'module.name.magazine',
            action: 'edit',
          },
          component: EditionDetail,
        },
        {
          path: '/magazine',
          name: 'MagazineOverview',
          meta: {
            title: 'magazine',
            help: 'module.name.magazine',
          },
          component: MagazineOverview,
        },
        {
          path: '/magazine/add',
          name: 'MagazineAdd',
          meta: {
            title: 'magazine',
            help: 'module.name.magazine',
            action: 'add',
          },
          component: MagazineDetail,
        },
        {
          path: '/magazine/:id',
          name: 'MagazineDetail',
          meta: {
            title: 'magazine',
            help: 'module.name.magazine',
            action: 'edit',
          },
          component: MagazineDetail,
        },
        {
          path: '/emails',
          name: 'EmailsOverview',
          meta: {
            title: 'emails',
          },
          component: EmailsOverview,
        },
        {
          path: '/emails/:id',
          name: 'EmailDetail',
          meta: {
            title: 'emails',
            action: 'edit',
          },
          component: EmailDetail,
        },
        {
          path: '/bookstore',
          name: 'BookStoreOverview',
          meta: {
            title: 'bookstore',
            help: 'module.name.bookstore',
          },
          component: BookStoreOverview,
        },
        {
          path: '/bookstore/add',
          name: 'BookStoreAdd',
          meta: {
            title: 'bookstore',
            help: 'module.name.bookstore',
            action: 'add',
          },
          component: BookStoreDetail,
        },
        {
          path: '/bookstore/:id',
          name: 'BookStoreDetail',
          meta: {
            title: 'bookstore',
            help: 'module.name.bookstore',
            action: 'edit',
          },
          component: BookStoreDetail,
        },
      ],
    },
    //  '/auth'
    {
      path: '/auth',
      alias: '/',
      component: OutsideLayout,
      children: [
        //  'login'
        {
          path: 'login',
          name: 'login',
          component: AuthWrapper,
        },
        //  'reset'
        {
          path: 'reset',
          name: 'reset',
          component: AuthWrapper,
        },
        //  'reset/:email/:code'
        {
          path: 'reset/:email/:code',
          name: 'inputResetPassword',
          component: AuthWrapper,
        },
        //  'accept/:email/:code'
        {
          path: 'accept/:email/:code',
          name: 'accept',
          component: AuthWrapper,
        },
      ],
    },
    //  '*'
    {
      path: '*',
      beforeEnter: pageNotFound,
    },
  ],
});
